import { Component, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'app-update-dialog',
    templateUrl: './app-update-dialog.component.html',
    styleUrls: ['./app-update-dialog.component.scss'],
    standalone: false
})
export class AppUpdateDialogComponent {
  @Output() confirmUpdate = new EventEmitter<boolean>();
  
  show: boolean = false;
  countdown: number = 60;
  private countdownInterval: any;

  openDialog(): void {
    this.show = true;
    this.countdown = 60;
    this.startCountdown();
  }

  closeDialog(): void {
    this.show = false;
    this.stopCountdown();
  }

  onConfirm(): void {
    this.stopCountdown();
    this.confirmUpdate.emit(true);
    this.closeDialog();
  }

  onCancel(): void {
    this.stopCountdown();
    this.confirmUpdate.emit(false);
    this.closeDialog();
  }

  private startCountdown(): void {
    this.countdownInterval = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        this.stopCountdown();
        this.confirmUpdate.emit(true);
        this.closeDialog();
      }
    }, 1000);
  }

  private stopCountdown(): void {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }
  }
}
